import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { IApplicationState } from '../../types/redux';
import { selectCurrentPageMeta } from '../../selectors/pagesMeta';
import { selectCurrentListingStatus } from '../../selectors/listings';

/**
 * Вычисляет текущий листинг и возвращает его статус
 */
export const useCurrentListingStatus = () => {
  const { pathname } = useLocation();
  const { type: pageType } = useSelector((state: IApplicationState) => selectCurrentPageMeta(state, pathname));
  const listingStatus = useSelector((state: IApplicationState) => selectCurrentListingStatus(state, pageType));
  const [status, setStatus] = useState(listingStatus);

  useEffect(() => {
    setStatus(listingStatus);
  }, [listingStatus]);

  return status;
};
